module.exports = __webpack_public_path__ + "img/tjls-logo-right.f5e750b0.png";